import "../Styles/Frontend/frontend.scss";
import "../Styles/Frontend/ai-summary.scss";

import "./Chunk/Frontend/data_tables_async";
import "./Chunk/Frontend/data_table_default";
import "./Chunk/Frontend/create_tab";
import "./chunk/frontend/ai_summary";